import * as React from 'react';
import { EditableTable2 } from 'react-pro-components';
import type { EditableTableProps } from 'react-pro-components/typings/components/editable-table-2/types';
import { Button } from 'ssc-ui-react';

import { $gt } from '@/common/appCtx';

import { usePermissions } from '../permissions';
import { useActivityTypeOptions } from './hooks/use-activity-types';
import { useHandleForm } from './hooks/use-handle-form';
import { useInitBreadcrumb } from './hooks/use-init-breadcrumb';
import { useInitForm } from './hooks/use-init-form';
import style from './index.module.less';
import { WorkstationActivityType } from './type';

const WorkstationActivityTypePage = () => {
  const [dataSource, setDataSource] = React.useState<WorkstationActivityType[]>([]);
  const [form] = EditableTable2.useForm<WorkstationActivityType>();
  const { loading: initLoading, refresh } = useInitForm(form, setDataSource);
  const { loading: submitLoading, submit } = useHandleForm(form, refresh);
  const loading = initLoading || submitLoading;
  const {
    activityTypeOptions,
    sequenceOptions,
  } = useActivityTypeOptions(dataSource);
  useInitBreadcrumb();
  const hasPermission = usePermissions();

  const editableTableProps: EditableTableProps<WorkstationActivityType> = {
    loading: loading,
    form,
    allowDeleteAll: true,
    columns: [
      {
        title: 'Activity Type',
        dataIndex: 'activity_type',
        key: 'activity_type',
        formDescriptor: {
          type: 'select',
          ctrlProps: { options: activityTypeOptions },
          required: true,
          rules: [{ required: true, message: 'Activity type is required!' }]
        },
      },
      {
        title: 'Operator Quantity',
        dataIndex: 'operator_quantity',
        key: 'operator_quantity',
        formDescriptor: {
          type: 'inputNumber',
          ctrlProps: {
            min: 0,
            max: 99999999,
            precision: 0,
          },
        },
      },
      {
        title: 'Sequence',
        dataIndex: 'sequence',
        key: 'sequence',
        hint: $gt('Define the position of this Activity Type in the workflow. A smaller number means it appears earlier in the Workflow and processes orders sooner'),
        formDescriptor: {
          type: 'select',
          ctrlProps: {
            options: sequenceOptions,
            allowClear: true,
          },
        },
      },
    ],
    scroll: { x: true },
    addButtonProps: { children: 'Add Activity Type' },
    onRowChange: () => {
      setDataSource(form.getRowsValues().slice());
    },
  };

  if (!hasPermission('workstationList')) {
    return null;
  }
  return (
    <div className={style.root}>
      <h3 className={style.title}>{ $gt('Workstation Activity Type') }</h3>
      <EditableTable2 {...editableTableProps} />
      <div className={style.footerContainer}>
        {hasPermission('workstationSet') && (
          <Button type="primary" loading={loading} onClick={submit}>{$gt('Confirm')}</Button>
        )}
      </div>
    </div>
  );
};

export default WorkstationActivityTypePage;
